import React, { useState, useEffect } from 'react';
import {
  Preview,
  Wrapper,
  Text,
  QueryBuilderTitle_with_PreviewButton,
  KeywordWrapper,
  Label,
  SubLabel,
  ErrorMessage,
  LoadingWrapper,
} from '../TopicBuilder/MainContent/QueryBuilder/TopicBuilder.styled';
import { DescForTopic, IconDiv, InfoDivWrapper, InfoWrapper } from './ViewCompetitive.styled.js'
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import DateSlider from '../../Common/DateSlider/dateSlider';
import ConnectChannels from '../TopicBuilder/MainContent/ConnectedChannels/ConnectedChannels';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Select from '../../Common/Select/Select';
import ChannelDropdown from '../ChatterTracker/MainComponent/ChatterTrackerBuilder/ShoppingChannels/ChannelDropdown';
import PopUp from '../../Common/PopUp/PopUp';
import Button from '../../Common/Button/Button';
import { formatDateFilter } from '../../utils';
import { competitiveIntelligenceListChatter, competitiveIntelligenceListTopic, createNewAnalysis, updateShowSideBar } from '../../store/redux/slices/competitiveIntelligenceSlice';
import SelectChannelPage from './SelectChannelPage.jsx';
import { QuestionIcon, SmallQuestionIcon } from '../../Common/SvgIcon/CommonSvgIcons.js';
import { activeTopicList } from '../../store/redux/slices/topicSlice.js';
import { chatterList } from '../../store/redux/slices/chatterSlice.js';
import Lottie from 'lottie-react';
import Loader from '../../assests/animation/Loader2.json';

const ToggleButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: min-content;
  color: #fff;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 400;
  border-radius: 6px;
  // border: 1px solid #d9d9d9;
border: 1px solid rgba(126, 126, 126, 1);
  & :not(:first-child) {
    border-left: 1px solid rgba(126, 126, 126, 1);
    border-radius: 0px;
  }
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: end;
  gap: 30px;

  font-size: 15px;
  font-weight: 600;

  & input {
    width: 200px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #d9d9d9;
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(162, 162, 162, 0.24);
    ${'' /* text-align: center; */} 
    padding: 1px 8px;
    color: #636363;
    font-family: Open Sans;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
  }
`;
const Option = styled.span`
  white-space: nowrap;
  cursor: pointer;
  color: #222;
  border-radius: 0px;
  width: 110px;
  height: 30px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 400;
    
    font-family: 'Inter';
  ${(props) =>
    props.selected &&
    `color: #fff;
      background: linear-gradient(90deg, #59A843 0%, #056D66 100%);
      // : props.selectedOption == 'customer chatters' ? '0px 0px !important' :
      border-radius: ${props.selectedOption == 'Social Topics' ? '4px 0px 0px 4px !important' : '0px 4px 4px 0px !important'};
      font-weight: 500;
  `};
  padding: ${(props) => props.padding};
`;

function CreateComparison({ setAnalysisListTopic, setAnalysisListChatter }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedTopicOne, setSelectedTopicOne] = useState(null);
  const [selectedDateRanges, setSelectedDateRanges] = useState(null);
  const [checked, setChecked] = useState(false);
  const [selectValid1, setSlectValid1] = useState(false);
  const [selectValid2, setSlectValid2] = useState(false);
  const [selectedTopicTwo, setselectedTopicTwo] = useState(null);
  const [topicOptions, setTopicOptions] = useState([]);
  const [topicOptionsTwo, setTopicOptionsTwo] = useState([]);
  const [channelType, setChannelType] = useState('Social Topics');
  const [channel, setChannel] = useState(null);
  const [channelTwo, setChannelTwo] = useState(null);
  const [startDateOne, setStartDateOne] = useState('');
  const [endDateOne, setEndDateOne] = useState('');
  const [startDateTwo, setStartDateTwo] = useState('');
  const [endDateTwo, setEndDateTwo] = useState('');
  const [channelError, setChannelError] = useState('');
  const [showModal, setShowModal] = useState(false)
  const [loader, setLoader] = useState(false)
  const [topicOne, setTopicOne] = useState()
  const [topicTwo, setTopicTwo] = useState()
  const { activeTopicListData } = useSelector((state) => state.topicBuilder) || [];
  const { chatterListDate } = useSelector((state) => state.chatterTracker) || [];
  const [topicOneError, setTopicOneError] = useState(false);
  const [topicTwoError, setTopicTwoError] = useState(false);

    const tenantName = useSelector((state) => state?.tenantAuth?.tenant_name || '');

  const { personalDetailsData } =
    useSelector((state) => state.tenantSetting) || {};
  const handleChannelSelect = (selected) => {

    setTopicTwoError(false)
    setTopicOneError(false)
    setChannelError(null)
    setTopicOne();
    setTopicTwo();
    if (channel === selected) {
      setChannel(null);
    } else {
      setChannel(selected);
    }
    let list = [];
    if (selected === 'Social Topics') {
      // list = (activeTopicListData?.filter((topic) => topic.channel === selected && topic.is_active === 0))
      // && topic.is_active === 0 topic.channel === selected &&
      list = activeTopicListData?.filter((topic) =>
        topic.is_active === 0
      );
    } else if (selected === "Customer Chatters") {

      // chatter.channel === selected?.toLowerCase() &&
      list = (chatterListDate?.filter((chatter) => chatter.is_active === 0))
      // 
    } else {
      list = [];
    }
    // const opt = list?.map((li) => {
    //   return li.topic_title || li.chatter_title
    // })

    setTopicOptions(list || [])

    if (list?.length > 0) {

      setShowModal(false)
    } else {
      setShowModal(true)
    }
  };

  // const handleChannelSelectTwo = (selected) => {
  //   // console.log(channel, selected, 'selected');
  //   if (channelTwo === selected) {
  //     setChannelTwo(null);
  //   } else {
  //     setChannelTwo(selected);
  //   }
  //   let list = [];
  //   if (channelType === 'Topic') {
  //     list = (activeTopicListData?.filter((topic) => topic.channel === selected && topic.is_active === 0))

  //   } else {
  //     list = (chatterListDate?.filter((chatter) => chatter.channel === selected?.toLowerCase() && chatter.is_active === 0))

  //   }

  //   // let list = activeTopicListData?.filter((topic) => topic.channel === selected && topic.is_active === 0)
  //   // console.log(list, "list");
  //   const opt = list?.map((li) => {
  //     return li.topic_title || li.chatter_title
  //   })
  //   if (opt?.length > 0) {
  //     setTopicOptionsTwo(opt)
  //   } else {
  //     setShowModal(true)
  //   }
  // };
  const handleButtonClick = (event) => {
    if (!topicOne || !topicTwo) {
      // if (!channel) {
      //   setChannelError('Select any one channel')
      // }
      if (!topicOne) {
        setTopicOneError(true)
      }
      if (!topicTwo) {
        setTopicTwoError(true)
      }
      return;
    }

    if (!topicOne?.start_date || !topicOne?.end_date || !topicTwo?.start_date || !topicTwo?.end_date) {
      if (!topicOne?.start_date || !topicOne?.end_date) {
        setSlectValid1(true)
      }
      if (!topicTwo?.start_date || !topicTwo?.end_date) {
        setSlectValid2(true)
      }

      return;
    }

    setLoader(true)
    let data = {}
    // const data = 
    if (!checked) {
      data = {
        job_id_1: topicOne?.job_id,
        start_date_1: selectedDateRanges.track1.start,
        end_date_1: selectedDateRanges.track1.end,
        job_id_2: topicTwo?.job_id,
        start_date_2: selectedDateRanges.track2.start,
        end_date_2: selectedDateRanges.track2.end,
        is_topic: channelType == 'Social Topics' ? true : false,
        "report_type": topicOne?.job_id == topicTwo?.job_id ? "self" : "different"
      }
    } else {
      data = {
        job_id_1: topicOne?.job_id,
        start_date_1: endDateOne && formatDateFilter(startDateOne),
        end_date_1: topicOne?.is_active == 0 ? null : endDateOne && formatDateFilter(endDateOne),
        job_id_2: topicTwo?.job_id,
        start_date_2: endDateOne && formatDateFilter(startDateOne),
        is_topic: channelType == 'Social Topics' ? true : false,
        end_date_2: topicOne?.is_active == 0 ? null : endDateOne && formatDateFilter(endDateOne),
        "report_type": "shared"
      }
    }

    dispatch(createNewAnalysis(data))
      .then((res) => {

        dispatch(activeTopicList());
        dispatch(chatterList());
        dispatch(competitiveIntelligenceListTopic()).then(
          (res) => {
            setAnalysisListTopic(res?.payload?.data)
          }
        );
        dispatch(competitiveIntelligenceListChatter()).then(
          (res) => {
            setAnalysisListChatter(res?.payload?.data)
          }
        );
        if (res?.payload?.data?.competitive_intelligence_id) {
          navigate('/competitiveIntelligence/ci_' + res?.payload?.data?.competitive_intelligence_id);

        }
        setLoader(false)
      })

      .catch((err) => {
        setLoader(false)
      });
  };

  const ToggleButton = ({
    options = [],
    onClick = () => { },
    padding = '5px 20px',
    option
  }) => {
    const [selectedOption, setSelectedOption] = useState(option);
    const handleSelectOption = (opt) => {
      if (selectedOption !== opt) {
        onClick(opt);
        setSelectedOption(opt);
      }
    };

    return (
      <ToggleButtonWrapper>
        {options?.map((op) => (
          <Option
            selectedOption={selectedOption}
            selected={selectedOption === op}
            onClick={() => handleSelectOption(op)}
            padding={padding}
            key={op}
          >
            {op}
          </Option>
        ))}
      </ToggleButtonWrapper>
    );
  };

  const handleChannelType = (type) => {
    if (type == 'Social Topics') {
      dispatch(updateShowSideBar('topic'))
    } else if (type == "Customer Chatters") {
      dispatch(updateShowSideBar('chatter'))
    }

    setChannel(null)
    setChannelTwo(null)
    setChannelType(type)
    setSelectedTopicOne({
      start_date: '',
      end_date: ''
    })
    setselectedTopicTwo({
      start_date: '',
      end_date: ''
    })
    handleChannelSelect(type)
  }

  const handleTopicOneChange = (opt) => {
    let selected = []

    if (channelType === 'Topic') {
      selected = activeTopicListData.find((option) => option.topic_title === opt)

    } else {
      selected = chatterListDate.find((option) => option.chatter_title === opt)
    }
    // setSelectedTopicOne(selected)
    // if(selectedTopicOne){
    setStartDateOne(formatDateFilter(selected?.start_date))
    setEndDateOne(formatDateFilter(selected?.end_date))
    // }
  }

  const formatValue =
    personalDetailsData?.app_preference?.date_format === 'dd/mm/yyyy'
      ? 'dd-MM-yyyy'
      : personalDetailsData?.app_preference?.date_format === 'mm/dd/yyyy'
        ? 'MM-dd-yyyy'
        : personalDetailsData?.app_preference?.date_format === 'yyyy/mm/dd'
          ? 'yyyy-MM-dd'
          : 'dd-MM-yyyy';
  const handleTopicTwoChange = (opt) => {
    let selected = []

    if (channelType === 'Topic') {
      selected = activeTopicListData.find((option) => option.topic_title === opt)

    } else {
      selected = chatterListDate.find((option) => option.chatter_title === opt)
    }
    // const selected = activeTopicListData.find((option) => option.topic_title === opt || option.chatter_title === opt)

    setselectedTopicTwo(selected)
    // if(selectedTopicTwo){
    setStartDateTwo(formatDateFilter(selected?.start_date))
    setEndDateTwo(formatDateFilter(selected?.end_date))
    // }
  }

  const dateHandler = (e, count) => {
    const { name, value } = e.target;
    if (name === 'firstPostDate') {
      count == 1 ? setStartDateOne(value) : setStartDateTwo(value);
    } else if (name === 'lastPostDate') {
      count == 1 ? setEndDateOne(value) : setEndDateTwo(value);
    }
  }

  const onDateSliderChange = (e) => {
    // console.log(e.startDate,"e",e);
    if (e.topicCount == 1) {
      setStartDateOne(formatDateFilter(e.startDate))
      setEndDateOne(formatDateFilter(e.endDate))
    } else {
      setStartDateTwo(formatDateFilter(e.startDate))
      setEndDateTwo(formatDateFilter(e.endDate))
    }
  }

  return (
    <Wrapper>
      {
        loader &&
        <LoadingWrapper>
          <div>
            <Lottie
              data-testid='loader'
              animationData={Loader}
              loop={true}
              width='100px'
              height='100px'
            />
          </div>
        </LoadingWrapper>
      }

      <Text>
        Compare brand performance, campaigns, and user engagement across platforms, competitors, and timeframes in one comprehensive view.
      </Text>
      <QueryBuilderTitle_with_PreviewButton>
        {/* , 'news coverage' */}
        <ToggleButton
          options={tenantName === 'snitch' ? ['Social Topics']: ['Social Topics', 'Customer Chatters']}
          onClick={handleChannelType}
          option={channelType}
        />
        <Preview onClick={handleButtonClick}>Generate</Preview>
      </QueryBuilderTitle_with_PreviewButton>
      <SelectChannelPage
        selectedDateRanges={selectedDateRanges}
        setSelectedDateRanges={setSelectedDateRanges}
        showSecondModule={true}
        chooseFocus={false}
        descVal={channelType == 'Chatter' ? 'Select interested chatter' : 'Select interested topic'}
        subLabelVal={'Select an active topic you want to evaluate or compare.'}
        handleTopicOneChange={handleTopicOneChange}
        topicOptions={topicOptions}
        selectedTopicOne={selectedTopicOne}
        startDateOne={startDateOne}
        endDateOne={endDateOne}
        onDateSliderChange={onDateSliderChange}
        // dateHandler={dateHandler}
        channelType={channelType}
        setTopicTwoError={setTopicTwoError}
        setTopicOneError={setTopicOneError}
        handleChannelSelect={handleChannelSelect}
        channel={channel}
        channelError={channelError}
        showModal={showModal}
        topicCount={1}
        setStartDateOne={setStartDateOne}
        setEndDateOne={setEndDateOne}
        setSelectedTopicOne={setSelectedTopicOne}
        setShowModal={setShowModal}
        formatValue={formatValue}
        setChannel={setChannel}
        topicOne={topicOne}
        topicTwo={topicTwo}
        setTopicOne={setTopicOne}
        setTopicTwo={setTopicTwo}
        topicOneError={topicOneError}
        topicTwoError={topicTwoError}
        setChecked={setChecked}
        checked={checked}
        setSlectValid1={setSlectValid1}
        setSlectValid2={setSlectValid2}
        selectValid2={selectValid2}
        selectValid1={selectValid1}
      />


    </Wrapper >
  );
}

export default CreateComparison;